import { selectOptionType } from ".";

export const investorTypePerson: selectOptionType[] = [
	{ id: "1", name: "Persona física" },
	{ id: "2", name: "Persona jurídica" }
];
